import { createContext, useReducer, useState, useContext } from 'react'

export const ConnectLogContext = createContext() 

export const connectLogReducer = (state, action) => {
    switch (action.type) {
        case 'SET_CONNECTLOG':
            return { connectLogs: action.payload }
        case 'CREATE_CONNECTLOG':
            return { connectLogs: [action.payload, ...state.connectLogs] }
        case 'UPDATE_CONNECTLOG':
            return { connectLogs: action.payload }
        case 'DELETE_CONNECTLOG':
            return { connectLogs: state.connectLogs.filter(u => u._id !== action.payload) }
        default:
            return state
    }
}

export const ConnectLogContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(connectLogReducer, { connectLogs: [] })
    const [targetConnectLog, setTargetConnectLog] = useState(null)
    return (
        <ConnectLogContext.Provider 
            value={{ ...state, dispatch, targetConnectLog, setTargetConnectLog}}>
                { children }
        </ConnectLogContext.Provider>
    )
}

export const useConnectLogContext = () => {
    const context = useContext(ConnectLogContext)
    if(!context) throw Error('useConnectLogContext must be used inside an ConnectLogContextProvider')
    return context
}